import { ENDPOINT_SUBSCRIPTIONS } from '../config'
import type {
  PaidPlanCode,
  PlanDocument,
  SubscriptionDocument,
} from '@/lib/types/subscription'
import AuthAxios from '@/lib/api/axios/AuthAxios'

/**
 * REST shape of GET /subscriptions/current. Mirrors backend
 * SubscriptionResponse — note that trialEligibility is REST-only and is NOT
 * synced via RxDB.
 */
export interface CurrentSubscriptionResponseDto {
  subscription: SubscriptionDocument
  plan: PlanDocument
  trialEligibility?: Partial<Record<PaidPlanCode, boolean>>
}

export async function getCurrentSubscription(): Promise<CurrentSubscriptionResponseDto> {
  const response = await AuthAxios.get<CurrentSubscriptionResponseDto>(
    `${ENDPOINT_SUBSCRIPTIONS}/current`,
  )
  return response.data
}
